import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Mission() {
  const missaoJuslabore = `Nossa missão é oferecer soluções digitais para os 
  advogados, facilitando o controle, gerenciamento, efetividade e a qualidade 
  da prestação de serviços jurídicos, incrementando o resultado financeiro para
  o profissional. `;
  return (
    <div className="container" style={{ textAlign: 'justify',
                                        border: '1px solid rgba(164,164,164,0.3)',
                                        borderRadius: '6px 6px 6px 6px',
                                        backgroundColor: '#ffffff',
                                        margin: '3% auto',
                                        boxShadow: '-4px 3px 8px -2px rgba(181,181,181,0.75)'
                                      }}>
      <Helmet>
        <title>Missão da plataforma Juslabore</title>
        <meta name="description" content={missaoJuslabore} />
      </Helmet>
      <h3 className="flex-column align-center" style={{ marginBottom: '5%' }}>
        NOSSA MISSÃO
      </h3>
      <p>{missaoJuslabore}</p>
      <hr style={{  border: '0',
                    height: '1px',
                    backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0),
                                      rgba(0, 0, 0, 0.20),
                                      rgba(0, 0, 0, 0))`}}></hr>
      <h3 className="flex-column align-center" style={{ margin: '5% auto' }}>
        NOSSA VISÃO
      </h3>
      <p>
      Ser referência mundial na transmissão de conhecimento jurídico, venda
      de serviços digitais, reconhecida pela qualidade e inovação na prestação
      de serviços. 
      </p>
      <hr style={{  border: '0',
                    height: '1px',
                    backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0),
                                      rgba(0, 0, 0, 0.20),
                                      rgba(0, 0, 0, 0))`}}></hr>
      <h3 className="flex-column align-center" style={{ margin: '5% auto' }}>
        NOSSOS VALORES
      </h3>
      <ol type='a' style={{ paddingLeft: '1.2em' }}>
        <li>
          promover a qualidade por meio de processos eficientes e seguros;
        </li>
        <li>
          incentivar o trabalho colaborativo e o respeito mútuo, valorizando o
          desempenho humano;
        </li>
        <li>
          agir com ética, responsabilidade, proporcionando isonomia de condições
          no convívio social e profissional; 
        </li>
        <li>
          compartilhar conhecimento com nossos clientes; 
        </li>
        <li>
          produzir e entregar serviços seguros, modernos, que produzam ganhos
          financeiros justos.
        </li>
      </ol>
    </div>
  );
}
